import { render, staticRenderFns } from "./TableRowItem.vue?vue&type=template&id=0c430f3a&scoped=true&"
import script from "./TableRowItem.vue?vue&type=script&lang=ts&"
export * from "./TableRowItem.vue?vue&type=script&lang=ts&"
import style0 from "./TableRowItem.vue?vue&type=style&index=0&id=0c430f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c430f3a",
  null
  
)

export default component.exports